import { render, staticRenderFns } from "./filters.vue?vue&type=template&id=ff2c2c24&scoped=true"
import script from "./filters.vue?vue&type=script&lang=js"
export * from "./filters.vue?vue&type=script&lang=js"
import style0 from "./filters.vue?vue&type=style&index=0&id=ff2c2c24&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2c2c24",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Providers/filters.vue
// module id = 2457
// module chunks = 31